import Calander from '../../../../components/calander/calander';
import DayView from './dayView';

const CalanderTraining = () => {
  return <Calander ModalComponent={DayView} DisplayModels={["AthleteWorkout"]} />;
};

export default CalanderTraining;